import elec from '../imgs/billPage/electric.png'
import clothes from '../imgs/billPage/clothes.png'
import gas from '../imgs/billPage/gas.png'
import grocery from '../imgs/billPage/grocery.png'
import gym from '../imgs/billPage/gym.png'
import left from '../imgs/transferPage/left.png'
import right from '../imgs/transferPage/right.png' 

const billImages = {
    Electric : elec,
    Clothes : clothes,
    Gas : gas,
    Grocery : grocery,
    Gym : gym
}

const transferImages = {
    IN : right,
    OUT : left
}

export {billImages , transferImages}